
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://jbkkoxrjfnoassvsgyqz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Impia2tveHJqZm5vYXNzdnNneXF6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk1NzU4MzAsImV4cCI6MjA1NTE1MTgzMH0.FNVjoBN0AfbeZpB3a3rP6JKW6qq5J9vVfq-HInBpLTw";

// Simple, single instance
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);

export const STORAGE_URL = SUPABASE_URL;
